import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LoginIcon from '@mui/icons-material/Login';
import SessionExpiredIllustration from 'src/assets/images/sessao_expirada.png';

export default function SessionExpiredModal({ open = false, onClose = () => {} }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  const handleHelp = () => {
    window.open(
      'https://ajuda.weesu.com.br/support/solutions/articles/151000211797-lancamento-da-vers%C3%A3o-2-6-11-em-15-04-2025',
      '_blank'
    );
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      fullWidth
      maxWidth='xs'
      fullScreen={fullScreen}
      aria-labelledby='session-expired-title'>
      <DialogTitle
        id='session-expired-title'
        sx={{ textAlign: 'center' }}>
        Eita, sua sessão sumiu! 😅
      </DialogTitle>

      <DialogContent>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          textAlign='center'
          gap={2}>
          <Box
            component='img'
            src={SessionExpiredIllustration}
            alt='Sessão expirada'
            sx={{ width: 160, height: 'auto' }}
          />
          <Typography variant='body2'>
            Parece que você <strong>ficou um tempo sem usar o sistema ou acessou de outro dispositivo</strong>.
          </Typography>
          <Typography variant='body2'>
            Se estiver usando o sistema em outro aparelho, <strong>pode continuar por lá sem problemas</strong>.
          </Typography>
          <Typography variant='body2'>
            <strong>Se quiser continuar por aqui</strong>, basta <strong>fazer o login novamente</strong> e seguir em
            frente.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant='outlined'
          startIcon={<HelpOutlineIcon />}
          onClick={handleHelp}
          fullWidth={fullScreen}
          sx={{
            borderColor: '#31b7bc',
            color: '#31b7bc',
            '&:hover': {
              borderColor: 'rgb(3, 36, 47)',
              color: 'rgb(3, 36, 47)',
            },
          }}>
          Ajuda
        </Button>
        <Button
          variant='contained'
          startIcon={<LoginIcon />}
          onClick={handleLogin}
          fullWidth={fullScreen}
          sx={{
            backgroundColor: '#31b7bc',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgb(3, 36, 47)',
            },
          }}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
